__turbopack_context__.v({
  "passport_transfer_signed_out": "PassportTransferSignedOut-module-scss-module__ClVesG__passport_transfer_signed_out",
  "passport_transfer_signed_out__description": "PassportTransferSignedOut-module-scss-module__ClVesG__passport_transfer_signed_out__description",
});
